import { EventEmitter, Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
@Injectable({
    providedIn: 'root'
})
export class EmitterService {
    // Event Dictionary
    private _emitters: { [id: string]: EventEmitter<any> } = {};
    private messageSource = new BehaviorSubject(false);
    currentMessage = this.messageSource.asObservable();
    // Set a new event in the store with a given id
    // as key
    public Get(id: string): EventEmitter<any> {
        if (!this._emitters[id]) {
            this._emitters[id] = new EventEmitter();
        }
        return this._emitters[id];
    }
    public changeMessage(flag: boolean) {
        this.messageSource.next(flag);
    }
}
